import React from "react";
import { PlusCircle } from "react-feather";

const PageHeader = ({ title, subtitle, onAdd, addLabel = "Add New", children }) => (
  <div className="page-header">
    <div className="add-item d-flex">
      <div className="page-title">
        <h4>{title}</h4>
        {subtitle && <h6>{subtitle}</h6>}
      </div>
    </div>
    <div className="d-flex align-items-center gap-2">
      {children}
      {onAdd && (
        <button className="btn btn-added" onClick={onAdd}>
          <PlusCircle className="me-2" size={16} />
          {addLabel}
        </button>
      )}
    </div>
  </div>
);

export default PageHeader;
